module.exports = __webpack_public_path__ + "static/media/img2.0663a662.jpg";